import React from 'react';
import { Box } from '@mui/material';

export default function parseCommentText(text) {
  if (!text) return '';
  const parts = [];
  let currentIndex = 0;
  const patterns = [
    { regex: /\*\*(.*?)\*\*/g, type: 'bold' },
    { regex: /```([\s\S]*?)```/g, type: 'code' },
    { regex: /```diff([\s\S]*?)```/g, type: 'diff' }
  ];
  const matches = [];
  patterns.forEach(({ regex, type }) => {
    let match;
    while ((match = regex.exec(text)) !== null) {
      matches.push({ start: match.index, end: match.index + match[0].length, type, content: match[1], fullMatch: match[0] });
    }
  });
  matches.sort((a, b) => a.start - b.start);
  matches.forEach((match, index) => {
    if (match.start > currentIndex) parts.push(text.slice(currentIndex, match.start));
    if (match.type === 'bold') {
      parts.push(
        <span key={`bold-${index}`} style={{ fontWeight: 'bold', color: '#f0f6fc' }}>
          {match.content}
        </span>
      );
    } else if (match.type === 'code') {
      parts.push(
        <Box key={`code-${index}`} sx={{ backgroundColor: '#161b22', border: '1px solid #30363d', borderRadius: '4px', padding: '8px 12px', margin: '8px 0', fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace', fontSize: '12px', color: '#f0f6fc', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
          {match.content}
        </Box>
      );
    } else if (match.type === 'diff') {
      const pre = text.slice(Math.max(0, match.start - 200), match.start).toLowerCase();
      const isProblematicBlock = pre.includes('problematic code');
      const previousPart = parts.length > 0 ? parts[parts.length - 1] : null;
      if (previousPart && previousPart.props && typeof previousPart.props.children === 'string') {
        const prev = previousPart.props.children.replace(/\r/g, '');
        const curr = match.content.replace(/\r/g, '');
        const prevTrim = prev.trim();
        const currTrim = curr.trim();
        if (/^diff/i.test(prevTrim) && prev.includes(currTrim)) {
          parts.pop();
        }
      }
      const rawLines = match.content.split('\n');
      const normalizedRaw = rawLines.map((line) => {
        let s = line.replace(/\r/g, '');
        if (/^\s*added\s*\+/.test(s)) s = s.replace(/^\s*added\s*/, '');
        if (/^\s*removed\s*-/.test(s)) s = s.replace(/^\s*removed\s*/, '');
        if (/^\s*(unchanged|context)\s+/.test(s)) s = s.replace(/^\s*(unchanged|context)\s+/, ' ');
        return s;
      });
      const filteredLines = normalizedRaw.filter(line => {
        const trimmed = line.trim();
        return trimmed !== 'diff' && trimmed !== '' && (trimmed.startsWith('+') || trimmed.startsWith('-') || trimmed.startsWith(' '));
      });
      const lines = [];
      let lastKey = null;
      filteredLines.forEach(line => {
        const key = line.trim();
        if (key !== lastKey) {
          lines.push(line);
          lastKey = key;
        }
      });
      const linesToRender = lines.filter(l => {
        const core = l.replace(/^[+\- ]/, '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!core) return false;
        return !pre.includes(core);
      });
      if (linesToRender.length === 0) { currentIndex = match.end; return; }
      const diffEls = linesToRender.map((line, lineIndex) => {
        const isAddition = line.startsWith('+');
        const isDeletion = line.startsWith('-');
        const bg = isProblematicBlock ? '#3d2e00' : (isAddition ? '#0c532d' : isDeletion ? '#67060c' : '#161b22');
        const fg = isProblematicBlock ? '#ffa657' : (isAddition ? '#7ee787' : isDeletion ? '#f85149' : '#f0f6fc');
        const border = isProblematicBlock ? '#f0883e' : (isAddition ? '#3fb950' : isDeletion ? '#f85149' : '#30363d');
        return (
          <Box key={lineIndex} sx={{ backgroundColor: bg, color: fg, padding: '2px 8px', fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace', fontSize: '12px', borderLeft: `4px solid ${border}` }}>
            {line}
          </Box>
        );
      });
      parts.push(
        <Box key={`diff-${index}`} sx={{ backgroundColor: '#0d1117', border: '1px solid #30363d', borderRadius: '4px', margin: '8px 0', overflow: 'hidden' }}>
          {diffEls}
        </Box>
      );
    }
    currentIndex = match.end;
  });
  if (currentIndex < text.length) parts.push(text.slice(currentIndex));
  return parts.length > 0 ? parts : text;
}




